import {
    getBatchDictList,
    getCategoryTree,
    getCurrency,
  } from '@/app/system-mgt/api/system'
import { formatDict } from '@/framework/utils'

const DictCode = [
  'cardType', // 证件类型
  'belonggroupname', // 归属集团
  'supplierType', // 供应商类型
  'Country', // 国家
  'registAddress', // 注册地
  'serviceType', // 服务类型
  'supplierNature', // 企业类型
  'transportType', // 运输方式
  'detectionDevice', // 检测设备
  'securityDevice', // 安全设备
  'taxpayerType', // 纳税人分类
  'warehouseDevice', // 仓库设备
  'manageType', // 管理分类
  'contactPersonType', // 联系人类型
  'cooperationType', // 合作期限
  'transactionRelationship', // 交易关系
  'supplierStatus', // 供应商状态
  'inspectResult', // 考察结果
  'billsType', // 考察结果
  'billsStatus', // 考察结果
  'supplierSource', // 供应商来源
  'accessBillsStatus', // 准入单-整体状态
  'accessStatus', // 准入单下品类-准入状态
  'accessBillsStatusAll', // 准入单状态-全部状态
  'accessBillsStatus', // 准入单状态-准入申请
  'accessProcessBillsStatus', // 准入单状态-准入过程使用
  'bankAccountType', // 银行账户类型
  'qualificationType', // 资质类型
  'inspectStatus', // 现场考察&样品检验的状态
  'internationalPayment', // 允许国际付款
  'paymentEntrustType', // 付款委托有效期
  'blackListType', // 黑名单类型
  'blackListEliminateStatus', // 黑名单淘汰管理的单据状态
  'creditType', // 授信类型
  'projectGroup', // 授信管理项目组
  // 以下为临时数据字典：根据情况在变化
  '_businessTypeVOS', // 当前供应商可准入的类型
  '_serviceTypeVOS', // 当前供应商可准入的服务类型
  '_bigType', // 大类
  '_smallType', // 小类
  'contractOutBuyType', // 销售合同类型
  'dataType', // 联系人修改的操作类型
  'PaymentCode', // 付款条件
]

const EBSCode = {
  // 品类（2级）
  'category2': {
    api: getCategoryTree,
    prop: {
      label: 'categoryName',
      value: 'categoryCode'
    }
  },
  // 品类（3级）
  'category': {
    api: getCategoryTree,
    prop: {
      label: 'categoryName',
      value: 'categoryCode'
    }
  },
  // 货币
  'currency': {
    api: getCurrency,
    prop: {
      label: 'currencyName',
      value: 'id'
    }
  }
}


const LocalDict = {
  // 如果接口没有的数据字典可以在这里录入
  // 财务信息状态
  financialStatus: [
    { label: '有效', value: '3' },
    { label: '无效', value: '1' }
  ],
  // 准入申请审批的单据状态
  admittanceAuditStatus: [
    { 'label': '申请审批中', 'value': '2' },
    { 'label': '准入中', 'value': '4' },
    { 'label': 'OA审批中', 'value': '6' },
    { 'label': '审批完成（通过）', 'value': '7' }
  ],
  // 准入过程的单据状态
  admittanceProcessStatus: [
    { 'label': '准入中', 'value': '4' },
    { 'label': 'OA审批中', 'value': '6' },
    { 'label': '审批完成（通过）', 'value': '7' }
  ],
  // 合同大类
  contractCategories: [
    { label: '外销', value: 'outSale' },
    { label: '内销', value: 'inSale' },
    { label: '集采', value: 'unifySign' },
    { label: '集采', value: 'backToBack' },
    { label: '集采', value: 'differSign' },
    { label: '自采', value: 'unifyPay' },
    { label: '自采', value: 'selfBuy' }
  ],
  // 合同小类
  contractType: [
    { label: '一口价合同', value: 'fixedPrice' },
    { label: '基差合同', value: 'basis' },
    { label: '基差移库合同', value: 'transfer' },
    { label: '保价合同', value: 'insured' },
    { label: '暂定价合同', value: 'tentative' },
    { label: '基差定价合同', value: 'basisEnsure' },
    { label: '移库定价合同', value: 'transferEnsure' },
    { label: '保价定价合同', value: 'insuredEnsure' },
    { label: '暂定价定价合同', value: 'tentativeEnsure' }
  ],
  contractCategory: [
    { label: '外销', value: '外销' },
    { label: '内销', value: '内销' },
    { label: '集采', value: '集采' },
    { label: '自采', value: '自采' }
  ],
  contractSmallType: [
    { label: '一口价', value: 'fixedPrice' },
    { label: '基差', value: 'basis' },
    { label: '基差移库', value: 'transfer' },
    { label: '保价合同', value: 'insured' },
    { label: '暂定价', value: 'tentative' },
    { label: '基差点价', value: 'basisEnsure' },
    { label: '移库点价', value: 'transferEnsure' },
    { label: '保价点价', value: 'insuredEnsure' },
    { label: '暂定价点价', value: 'tentativeEnsure' },
    { label: '一揽子采购', value: 'wholesale' }
  ]
}

const DealDict = {
  materials: [], // 物料
  area: [], // 片区
  level: [], // 品类
  contractStatus: []// 合同状态
}

const asyncDict = {}
DictCode.map(code => {
  asyncDict[code] = []
})
Object.keys(EBSCode).map(code => {
  asyncDict[code] = []
})

const state = {
  ...LocalDict,
  ...asyncDict,
  ...DealDict
}

const mutations={
  SET_DICT: (state, data)=> {
    const { key, value } = data
    state[key] = value
  }
}

const actions= {
  /**
   * 通用获取数据字典哪个地方要用
   * 先dispatch（codeList）（内部判断是否从接口获取）
   * @param codeList 数据字典code列表
   */
  getDict({ commit, state, dispatch }, codeList) {
    const tasks = []
    console.log(codeList, 'getDict')
    codeList.forEach(item => {
      tasks.push(dispatch('getSingleDict', item))
    })
    return Promise.all(tasks)
  },
  /**
   * 获取单个数据字典
   * code
   * @return Promise
   */
  getSingleDict({ commit, state }, code) {
    return new Promise((resolve, reject) => {
      if (state[code] && state[code].length) {
        resolve(state[code])
      } else if (DictCode.indexOf(code) > -1) {
        getBatchDictList([code]).then(res => {
          const value = formatDict(res.data[code], { label: 'dictItemName', value: 'dictItemCode' })
          commit('SET_DICT', {
            key: code,
            value
          })
          resolve(value)
        }).catch(() => {
          reject(null)
        })
      } else if (EBSCode[code]) {
        EBSCode[code].api({}).then(res => {
          let value = null
          if (code === 'category') {
            // 扁平化第一级
            const list = []
            res.data.forEach(o => {
              list.push(...o.children)
            })
            value = formatDict(list, EBSCode[code].prop)
          } else if (code === 'category2') {
            // 扁平化第一级
            const list = []
            res.data.forEach(o => {
              list.push(...o.children)
            })
            value = formatDict(list, EBSCode[code].prop, 2)
          } else {
            value = formatDict(res.data.result || res.data, EBSCode[code].prop)
          }
          commit('SET_DICT', {key: code,value})
          resolve(value)
        }).catch(() => {
          reject(null)
        })
      } else {
        reject(null)
      }
    })
  },
  getDealDict({ commit, state }, data) {
    commit('SET_DICT', data)
  },
  // 清空临时使用的数据字典
  clearDict({ commit }, codeList) {
    codeList.forEach(key => {
      commit('SET_DICT', {
        key,
        value: []
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
